export const ACTION_COLORS = [
    "slate",
    "gray",
    "zinc",
    "stone",
    "graphite",
    "red",
    "crimson",
    "ruby",
    "rose",
    "pink",
    "blush",
    "magenta",
    "fuchsia",
    "plum",
    "purple",
    "violet",
    "lavender",
    "indigo",
    "cobalt",
    "blue",
    "azure",
    "sky",
    "cyan",
    "aqua",
    "orange",
    "coral",
    "tangerine",
    "amber",
    "gold",
    "yellow",
] as const

export type SavedActionColor = (typeof ACTION_COLORS)[number]

export const ACTION_ICONS = [
    "sparkles",
    "play",
    "check",
    "commit",
    "push",
    "pull-request",
    "git-branch",
    "terminal",
    "wrench",
    "search",
    "test",
    "rocket",
    "package",
    "wrap-up",
    "bug",
    "refresh",
    "close",
    "trash",
    "code",
    "file",
    "save",
    "upload",
    "download",
    "merge",
    "fork",
    "checklist",
    "shield",
    "hammer",
    "database",
    "workflow",
    "book",
    "idea",
    "timer",
    "goal",
    "message",
    "star",
] as const

export type SavedActionIcon = (typeof ACTION_ICONS)[number]

export const ACTION_VISIBILITY_CONDITIONS = ["task-idle", "task-running", "git-repository", "git-working-changes", "git-unpushed-commits"] as const

export type SavedActionVisibilityCondition = (typeof ACTION_VISIBILITY_CONDITIONS)[number]

export const ACTION_VISIBILITY_MISMATCH_BEHAVIORS = ["disable", "hide"] as const

export type SavedActionVisibilityMismatchBehavior = (typeof ACTION_VISIBILITY_MISMATCH_BEHAVIORS)[number]

export interface SavedActionSource {
    templateId: string
    templateVersion: number
}

export const SAVED_ACTION_SESSION_LAUNCH_KINDS = ["delegate", "review", "council"] as const
export const MAX_SAVED_ACTION_SESSION_TARGETS = 8

export type SavedActionSessionLaunchKind = (typeof SAVED_ACTION_SESSION_LAUNCH_KINDS)[number]

export interface SavedActionSessionLaunch {
    kind: SavedActionSessionLaunchKind
    description?: string
    maxTargets?: number
}

export interface SavedAction {
    id: string
    name: string
    prompt: string
    icon: SavedActionIcon
    color: SavedActionColor
    enabled: boolean
    requiresConfirmation: boolean
    allowCombining: boolean
    visibility: {
        match: "all" | "any"
        conditions: SavedActionVisibilityCondition[]
        onMismatch: SavedActionVisibilityMismatchBehavior
    }
    sessionLaunch?: SavedActionSessionLaunch
    source?: SavedActionSource
    createdAt: string
    updatedAt: string
}

export interface SavedActionsRecord {
    v: 1
    actions: SavedAction[]
    updatedAt: string
}

export interface SavedActionDraft {
    name: string
    prompt: string
    icon: SavedActionIcon
    color: SavedActionColor
    requiresConfirmation: boolean
    allowCombining: boolean
    visibility: SavedAction["visibility"]
    sessionLaunch?: SavedActionSessionLaunch
}

export interface SavedActionTemplate {
    templateId: string
    templateVersion: number
    enabledByDefault: boolean
    enableOnUpgradeThroughVersion?: number
    insertBeforeTemplateId?: string
    action: SavedActionDraft
}
